import { REDIRECT_DELAY } from '../deposit/constants';

export function redirect(url: string): void {
  setTimeout(() => {
    window.location.href = url;
  }, REDIRECT_DELAY);
}
